import { graphql } from 'react-relay';

export const checkLookPage = graphql`
  mutation checkLookPageMutation($refundId: String!, $pageType: PageType!) {
    checkLookPage(refundId: $refundId, pageType: $pageType) {
      result
    }
  }
`;
